class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.content.addEventListener('mouseleave', this.onFocusOut.bind(this));
    this.content.addEventListener('mouseenter', this.onFocus.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onLeave.bind(this));
  }

  onFocusOut() {
    this.mainDetailsToggle.setAttribute('out_content', '');
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 100);  // Increased timeout
  }

  onFocus() {
    this.mainDetailsToggle.setAttribute('out_button', '');
    this.mainDetailsToggle.removeAttribute('out_content');
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.animations.forEach((animation) => animation.play());
    }
  }

  onLeave() {
    if (!this.header) return;
    this.header.preventHide = false;
    this.mainDetailsToggle.setAttribute('out_button', '');
    setTimeout(this.close.bind(this), 150);
  }

  close() {
    if (this.mainDetailsToggle.getAttribute('out_content') === '' && this.mainDetailsToggle.getAttribute('out_button') === '') {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = true;
    const siblings = this.parentElement.parentElement.children;
    Array.from(siblings).forEach((sibling) => {
      const details = sibling.querySelector('details');
      if (details && details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
      }
    });
    this.mainDetailsToggle.setAttribute('out_content', '');
    this.mainDetailsToggle.removeAttribute('out_button');
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.setAttribute('current', '');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);